import type { Week } from "./types";

export const DELIVERY_MOVE_LIST_FILE_NAME = "DeliveryMovieList";

export const WEEKS: Array<Week> = ["日", "月", "火", "水", "木", "金", "土"];
